import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import {
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  Typography,
} from '@mui/material';
import {
  colorArray10,
  npsSmileyFilledIcons,
  npsSmileyOutlinedIcons,
} from '../../AddQuestions/AnswerFormat/NpsFormatWithSmileys/utility/utility';

// Styling for grid items
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  // textAlign: 'center',
  color: theme.palette.text.primary,
}));

export default function NpsSmileyRating({
  options,
  label,
  optionsFontStyle,
  optionsFontSize,
  selectedSmileyId,
  setSelectedSmileyId,
  onClick,
  error,
}) {
  const newFeelingArray = npsSmileyOutlinedIcons.map((option, index) => ({
    id: index,
    // title: option.opt_text,
    color: colorArray10[index],
    icon: npsSmileyOutlinedIcons[index],
    iconOutline: npsSmileyFilledIcons[index],
  }));
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container direction="row">
        {newFeelingArray.map((path, index) => {
          let val = index + 1;
          return (
            <Grid item xs={1} key={val} mt={2}>
              <Item
                sx={{
                  fontSize: { sm: '10px', md: '14px', lg: '18px', xs: '10px' },
                }}
              >
                <IconButton onClick={() => onClick(val)} sx={{ p: 0 }}>
                  <Icon
                    className={
                      selectedSmileyId
                        ? selectedSmileyId === val
                          ? `${path.iconOutline}`
                          : `${path.icon}`
                        : `${path.icon}`
                    }
                    sx={{
                      color: selectedSmileyId
                        ? selectedSmileyId === val
                          ? `${path.color}`
                          : `#C6C6C6`
                        : `${path.color}`,
                      fontSize: '1.5rem',
                    }}
                  />
                </IconButton>
              </Item>

              <Item
                sx={{
                  fontSize: {
                    sm: '10px',
                    md: '14px',
                    lg: '18px',
                    xs: '10px',
                  },
                  mt: 1,
                  // textAlign:
                  //   val === 1 ? 'left' : val === 10 ? 'right' : 'center', // Aligns labels properly
                }}
              >
                {val === 1 && (
                  <Typography
                    variant="body3"
                    sx={{
                      fontFamily: optionsFontStyle
                        ? `${optionsFontStyle}!important`
                        : 'Poppins',
                      fontSize: optionsFontSize
                        ? `${optionsFontSize}px`
                        : '0.875rem',
                      whiteSpace: 'nowrap',
                      ml: options[0].opt_label.length === 1 ? '8px' : '2px',
                    }}
                  >
                    {options[0].opt_label}
                  </Typography>
                )}
                {val === 10 && (
                  <Typography
                    sx={{
                      fontFamily: optionsFontStyle
                        ? `${optionsFontStyle}!important`
                        : 'Poppins',
                      fontSize: optionsFontSize
                        ? `${optionsFontSize}px`
                        : '0.875rem',
                      whiteSpace: 'nowrap',
                      ml: options[1].opt_label === 1 ? '1px' : '-76px', // Adjust margin-left if needed
                    }}
                  >
                    {options[1].opt_label}
                  </Typography>
                )}
              </Item>

              {/* <Item
                sx={{
                  fontSize: {
                    sm: '10px',
                    md: '14px',
                    lg: '18px',
                    xs: '10px',
                  },
                  mt: 1,
                }}
              >
                {val === 1 && (
                  <Typography
                    variant="body3"
                    sx={{
                      fontFamily: optionsFontStyle
                        ? `${optionsFontStyle}!important`
                        : 'Poppins',
                      fontSize: optionsFontSize
                        ? `${optionsFontSize}`
                        : '0.875rem',
                      whiteSpace: 'nowrap',
                      // mr: 3,
                    }}
                  >
                    {options[0].opt_label}
                  </Typography>
                )}
                {val === 10 && (
                  <Typography
                    variant="body3"
                    sx={{
                      fontFamily: optionsFontStyle
                        ? `${optionsFontStyle}`
                        : 'Poppins',
                      fontSize: optionsFontSize
                        ? `${optionsFontSize}`
                        : '0.875rem',
                      whiteSpace: 'nowrap',
                      marginLeft: -8.4,
                    }}
                  >
                    {options[1].opt_label}
                  </Typography>
                )}
              </Item> */}
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          {error && (
            <FormHelperText
              variant="body4"
              color="error"
              sx={{ color: '#d32f2f' }}
            >
              {error}
            </FormHelperText>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
